import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { PhoneInputComponent } from './phone-input.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PhoneInputComponent
  ],
  imports: [
    CommonModule,
    DropdownModule,
    InputMaskModule,
    InputTextModule,
    ReactiveFormsModule,
  ],
  exports: [
    PhoneInputComponent
  ]
})
export class PhoneInputModule { }
